import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import type { InsuranceCoverage, InsuranceCoverageCreate, InsuranceCoverageUpdate } from "@/types/insurance-coverage";
import { createInsuranceCoverage, deleteInsuranceCoverage, updateInsuranceCoverage } from "./insurance";
import { insuranceQueryKeys } from "./insurance-query";
import { invalidateByKey } from "@/api/utils/query-helpers";
export const useCreateInsuranceCoverageMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp,
      onSettled: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export const useUpdateInsuranceCoverageMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp3,
      onSettled: _temp4
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export const useDeleteInsuranceCoverageMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp5,
      onSettled: _temp6
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
function _temp(t0) {
  const {
    patientId,
    input
  } = t0;
  return createInsuranceCoverage(patientId, input);
}
function _temp2(_res, _err, vars) {
  invalidateByKey(insuranceQueryKeys.list(vars.patientId));
}
function _temp3(t0) {
  const {
    patientId,
    coverageId,
    input
  } = t0;
  return updateInsuranceCoverage(patientId, coverageId, input);
}
function _temp4(_res, _err, vars) {
  invalidateByKey(insuranceQueryKeys.list(vars.patientId));
}
function _temp5(t0) {
  const {
    patientId,
    coverageId
  } = t0;
  return deleteInsuranceCoverage(patientId, coverageId);
}
function _temp6(_ok, _err, vars) {
  invalidateByKey(insuranceQueryKeys.list(vars.patientId));
}